import React from "react";
import GlobalDialog from "../mui/Dialogue/GlobalDialog";
import { AddButton, CancelButton, SaveButton } from "../mui/Buttons/Buttons";
import { Autocomplete, Box, Stack, TextField } from "@mui/material";
import { useFormik, Form, FormikProvider } from "formik";
import { getUsers } from "../../redux/features/jobApplicationSlice";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
    addPrjectClass,
    getProjectClasses,
    getProjectsPreData,
} from "../../redux/features/mastersSlice";
import { useSnackbar } from "notistack";
export const AddProjectClassPopup = ({ params }) => {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(false);
    const data = useSelector((state) => state.masters);

    const Schema = Yup.object().shape({
        className: Yup.string().required("className is required"),
        classDescription: Yup.string().required("classDescription is required"),
        projectId: Yup.string().required("projectId is required"),
    });

    const formik = useFormik({
        initialValues: {
            className: "",
            classDescription: "",
            projectId: "",
        },
        validationSchema: Schema,
        onSubmit: (values, { resetForm }) => {
            dispatch(addPrjectClass(values)).then((res) => {
                if (res.payload.status === "failed") {
                    enqueueSnackbar(res.payload.message, { variant: "error" });
                } else if (res.payload.status === "success") {
                    setOpen(false);
                    resetForm();
                    dispatch(getProjectClasses());
                    enqueueSnackbar(res.payload.message, {
                        variant: "success",
                    });
                }
            });
        },
    });
    return (
        <div>
            <GlobalDialog
                title="Add Project Class"
                open={open}
                setOpen={setOpen}
                fullWidth
                maxWidth={"sm"}
                popupButton={
                    <AddButton
                        action={() => {
                            dispatch(getProjectsPreData());
                            setOpen(true);
                        }}
                    >
                        Add Project Class
                    </AddButton>
                }
                content={
                    <>
                        <FormikProvider value={formik}>
                            <Form onSubmit={formik.handleSubmit}>
                                <Box>
                                    <Stack direction={"column"} spacing={2}>
                                        <Autocomplete
                                            disablePortal
                                            name="projectId"
                                            id="combo-box-demo"
                                            options={data.projectsPreData}
                                            getOptionLabel={(option) =>
                                                option.name
                                            }
                                            onChange={(e, option) => {
                                                formik.setFieldValue(
                                                    "projectId",
                                                    option.id
                                                );
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    disabled
                                                    fullWidth
                                                    {...params}
                                                    label="Project"
                                                    error={
                                                        formik.touched
                                                            .projectId &&
                                                        Boolean(
                                                            formik.errors
                                                                .projectId
                                                        )
                                                    }
                                                    helperText={
                                                        formik.errors.projectId
                                                    }
                                                />
                                            )}
                                        />
                                        <TextField
                                            label="Class Name"
                                            fullWidth
                                            name="className"
                                            value={formik.values.className}
                                            onChange={formik.handleChange}
                                            error={
                                                formik.touched.className &&
                                                Boolean(formik.errors.className)
                                            }
                                            helperText={formik.errors.className}
                                        />

                                        <TextField
                                            label="Class Description"
                                            fullWidth
                                            name="classDescription"
                                            value={
                                                formik.values.classDescription
                                            }
                                            multiline
                                            rows={3}
                                            onChange={formik.handleChange}
                                            error={
                                                formik.touched
                                                    .classDescription &&
                                                Boolean(
                                                    formik.errors
                                                        .classDescription
                                                )
                                            }
                                            helperText={
                                                formik.errors.classDescription
                                            }
                                        />
                                    </Stack>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            marginTop: 2,
                                        }}
                                    >
                                        <Stack spacing={2} direction={"row"}>
                                            <CancelButton
                                                action={() => setOpen(false)}
                                            >
                                                Cancel
                                            </CancelButton>
                                            <SaveButton type="submit">
                                                {data.loading
                                                    ? "Saving..."
                                                    : "Save"}
                                            </SaveButton>
                                        </Stack>
                                    </Box>
                                </Box>
                            </Form>
                        </FormikProvider>
                    </>
                }
            />
        </div>
    );
};
